module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./NoviceCourseDetailView.js"));
	}, "NoviceCourseDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=NoviceCourseDetailView!./src/pages/Shop/Member/Personal/NoviceCourse/NoviceCourseDetail/NoviceCourseDetailView.js
// module id = 1486
// module chunks = 418